import { BaseBadge, SmallBaseBadge } from "./BaseBadge";
import { BadgeProps } from "./types";
import "../../designTokens/variables.css";

export const SecondaryBadge = (props: BadgeProps) => {
  return <BaseBadge backgroundColor="var(--color-secondary-800)" {...props} />;
};

export const SmallSecondaryBadge = (props: BadgeProps) => {
  return (
    <SmallBaseBadge backgroundColor="var(--color-secondary-800)" {...props} />
  );
};
